import { AutoForm } from "components/Form/AutoForm"
import { getInitialValue } from "components/Form"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { useMemo } from "react"
import { useTranslator } from "components/Translator"
import { valueReducer } from "@w3rone/json-schema-form"

export const ContactForm = ({
  form,
  entity,
  onSuccess,
  submitLabel,
  preparedMessages,
  messageFieldName,
}) => {
  const connectedUser = useConnectedUser()
  const translator = useTranslator()

  const enhancedForm = useMemo(
    () =>
      connectedUser
        ? addUserInfosToForm(connectedUser, form, translator)
        : form,
    [connectedUser, form, translator],
  )

  return (
    <AutoForm
      schema={enhancedForm}
      initialValue={{ [form.title]: getInitialValue(form, entity) }}
      onSuccess={onSuccess}
      valueReducer={preparedMessageReducer({
        formRootName: enhancedForm.title,
        messageFieldName,
        preparedMessages,
      })}
      submitLabel={submitLabel}
    />
  )
}

const addUserInfosToForm = (user, form, translator) => {
  const enhancedForm = {
    ...form,
  }

  const phoneProperties = ["phone", "mobile"]
  const hasPhone = phoneProperties.some((property) => user[property])

  if (enhancedForm.properties.phone) {
    enhancedForm.properties.phone.options = {
      ...enhancedForm.properties.phone.options,
      layout: "card",
      caption: hasPhone
        ? phoneProperties
            .map((property) => user[property]?.formatted)
            .filter(Boolean)
            .join(", ")
        : translator.trans("ContactForm.infoUnavailable", null, "components"),
    }

    enhancedForm.properties.phone.options.attr = {
      ...enhancedForm.properties.phone.options.attr,
      disabled: !hasPhone,
    }
  }

  if (enhancedForm.properties.email) {
    enhancedForm.properties.email.options = {
      ...enhancedForm.properties.email.options,
      layout: "card",
      caption: user.username
        ? user.username
        : translator.trans("ContactForm.infoUnavailable", null, "components"),
    }

    enhancedForm.properties.email.options.attr = {
      ...enhancedForm.properties.email.attr,
      disabled: !user.username,
    }
  }

  if (enhancedForm.properties.website) {
    enhancedForm.properties.website.options = {
      ...enhancedForm.properties.website.options,
      layout: "card",
      caption: user.website
        ? user.website
        : translator.trans("ContactForm.infoUnavailable", null, "components"),
    }

    enhancedForm.properties.website.options.attr = {
      ...enhancedForm.properties.website.attr,
      disabled: !user.website,
    }
  }

  return enhancedForm
}

const preparedMessageReducer =
  ({ formRootName, messageFieldName, preparedMessages }) =>
  (state, action) => {
    const newValue = valueReducer(state, action)

    if (action.payload.name === `${formRootName}[preparedMessage]`) {
      const selectedPreparedMessage = preparedMessages.find(
        (preparedMessage) => preparedMessage.id == action.payload.value,
      )

      if (selectedPreparedMessage) {
        return {
          [formRootName]: {
            ...newValue[formRootName],
            [messageFieldName]: selectedPreparedMessage.content,
          },
        }
      }
    }

    return newValue
  }
